import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { CONTACT, OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function GuidelinesPage() {
  return (
    <LegalLayout
      title="Community Guidelines"
      subtitle={`Keep ${OPERATOR.product} safe and welcoming for everyone.`}
    >
      <LegalSection title="Our values">
        <LegalP>
          {OPERATOR.product} is a photo-first social space for real friends and creators. Be
          respectful, authentic, and mindful of others&apos; privacy—especially with Contacts-only
          audiences.
        </LegalP>
      </LegalSection>

      <LegalSection title="Allowed content">
        <LegalUl
          items={[
            "Original photos and short videos (Frames, Drifts, Parallel) you have the right to share.",
            "Captions, vibes, and comments that add context without harming others.",
            "Creative expression within the law and these guidelines.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Not allowed">
        <LegalUl
          items={[
            "Illegal content, including child sexual abuse material (CSAM)—zero tolerance; report immediately.",
            "Harassment, bullying, threats, or hate speech targeting protected characteristics.",
            "Non-consensual intimate imagery (NCII) or sharing private chats without permission.",
            "Spam, scams, impersonation, or misleading promotions.",
            "Violence, gore intended to shock, or dangerous acts encouraging harm.",
            "Copyright or trademark infringement—see our Copyright policy.",
            "Buying or selling engagement, or manipulating Sparks, invites, or ads.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Privacy & audiences">
        <LegalP>
          Respect audience settings. Do not repost Contacts-only content publicly. Private
          accounts connect through contact sync—not by bypassing follow restrictions.
        </LegalP>
      </LegalSection>

      <LegalSection title="Reporting">
        <LegalP>
          Use Report on posts, comments, profiles, or chat messages. For urgent safety issues,
          email{" "}
          <a href={`mailto:${CONTACT.support}`} className={tw.link}>
            {CONTACT.support}
          </a>{" "}
          with links and usernames. See{" "}
          <Link to="/child-safety" className={tw.link}>
            Child safety
          </Link>{" "}
          for CSAM.
        </LegalP>
      </LegalSection>

      <LegalSection title="Enforcement">
        <LegalP>
          We may remove content, limit distribution, suspend features, or ban accounts. Serious or
          repeat violations may be reported to authorities. Decisions are made under our{" "}
          <Link to="/terms" className={tw.link}>
            Terms
          </Link>
          ; there is no guaranteed appeal path for clear policy breaches.
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
